import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { GetSubscriptionPlans } from "../apiconstants/constants";

const featureMap = {
  "Starter Plan": "Job & candidate management, resume parsing, AI matching",
  "Professional Plan": "Everything in Basic + AI-powered video & coding tests, submission tracking",
  "Enterprise Plan": "Everything in Professional + Client & vendor management, team collaboration, lead management.",
};

const PricingPlans = () => {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await axios.get(GetSubscriptionPlans.APIURL);
        const filteredPlans = response.data.filter(plan => plan.planName !== "Trail Plan");
        setPlans(filteredPlans);
      } catch (error) {
        console.error("Failed to fetch pricing plans:", error);
      }
    };

    fetchPlans();
  }, []);

  return (
    <div className="elementor-widget-container mt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h2>Pricing Plan</h2>
            </div>
          </div>
        </div>

        <div className="row">
          {plans.map((plan) => (
            <div className="col-sm-12 col-lg-4 col-xl-4 col-md-4" key={plan.planID}>
              <div className="item-knackhire mt-3">
                <div className="info">
                  <h4 className="pricing-headings">{plan.planName}</h4>
                  <p style={{ height: '80px' }}>
                    {featureMap[plan.planName] || "Plan features coming soon..."}
                  </p>
                  <p style={{ height: '30px' }}>{plan.interviewLimit} Interviews</p>
                  <hr />
                  <p>${plan.price} - Monthly</p>
                  <hr />
                  <p>${plan.price} - Annual Cost (2 months free)</p>
                  <Link to="/Home">
                    <p>
                      <b>
                        Subscribe <i className="fa fa-arrow-right"></i>
                      </b>
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .item-knackhire {
          padding: 30px;
          position: relative;
          z-index: 1;
          border-radius: 5px;
          box-shadow: 0 0 10px #cccccc;
          height: 400px;
        }

        .site-heading h2::after {
          background: #ffffff;
          bottom: 0;
          content: "";
          height: 2px;
          left: 50%;
          margin-left: 20px;
          position: absolute;
          width: 5px;
        }
      `}</style>
    </div>
  );
};

export default PricingPlans;
